'use client';
import { MouseEvent } from 'react';
import { ModalID, useModal, type ProductDetailsData } from '@repo/ui/src/modules/UI';
import useAddToBasket from '@hooks/basket/useAddToBasket';
import CallToActionButton from '@components/Product/CallToActionButton';
import Product from '@models/product';

interface Props {
  product: ProductDetailsData;
}

const ProductDetailsDrawerCTA = ({ product }: Props) => {
  const { close } = useModal(ModalID.productDetails);
  const { trigger, isMutating } = useAddToBasket();

  const productModel = product as unknown as Product;

  const handleAddToCart = async (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    try {
      await trigger([productModel]);
    } finally {
      close();
    }
  };

  return (
    <CallToActionButton
      product={productModel}
      onClickAddToCart={handleAddToCart}
      buttonProcessing={isMutating}
      buttonProps={{ full: true }}
    />
  );
};

export default ProductDetailsDrawerCTA;
